import React, { useState } from 'react'
import BehavioralObservation from '../../../services/behavioral-observation'
import PsychologicalInterview from '../../../services/psychological-interview'
import TestApplication from '../../../services/test-application'
import * as S from './styled'

type PageProps = {
  match: any
}

const InternalAssessment = ({ match }: PageProps) => {
  console.log(match)
  const [tab, setTab] = useState<number>(0)
  return (
    <S.Wrapper>
      <S.TabBox>
        <S.TabItem
          onClick={() => setTab(0)}
          className={tab === 0 ? 'selected' : ''}
        >
          Entrevista Psicológica
        </S.TabItem>
        <S.TabItem
          onClick={() => setTab(1)}
          className={tab === 1 ? 'selected' : ''}
        >
          Aplicação de Teste
        </S.TabItem>
        <S.TabItem
          onClick={() => setTab(2)}
          className={tab === 2 ? 'selected' : ''}
        >
          Observação Comportamental
        </S.TabItem>
      </S.TabBox>
      {tab === 0 && <PsychologicalInterview match={match} setTab={setTab} />}
      {tab === 1 && <TestApplication match={match} setTab={setTab} />}
      {tab === 2 && <BehavioralObservation match={match} />}
    </S.Wrapper>
  )
}

export default InternalAssessment
